import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { arrayOf, shape, number, string } from "prop-types";
import { isAgency, isInternal, token } from "../../../modules/auth";
import TrapezeHeader from "Components/TrapezeHeader";
import { FaChevronRight } from "react-icons/fa";
import { isOfferVisible } from "../../../utils";
import { formatDate } from "../../../modules/dates";
import { checkVenueForPreferredProgramme } from "../../../services/hotelGroupService/preferredProgrammesService";

const agencyTypes = ["commission-offers", "agency-rates", "fam-trips"];

//const filterItems = (items, isAgency) =>
//  isAgency
//    ? items
//    : items.filter(item => !agencyTypes.includes(item.type.name));

const renderOffer = ({ id, title, valid_to, valid_from }, index, array) => {
  const validFrom = formatDate(valid_from, "DD/MM/YYYY");
  const validTo = formatDate(valid_to, "DD/MM/YYYY");
  return (
    <li
      key={id}
      className={`py-5 px-3 ${index < array.length - 1 &&
        "border-b-2 border-light-blue-grey"}`}
    >
      <Link to={`/offer/${id}`} className="text-black flex">
        <div className="w-4/5">
          <h3 className="mb-2">{title}</h3>
          <p
            title={"Valid between"}
            className="text-dark-red uppercase text-sm font-semibold mb-0"
          >
            {validFrom} - {validTo}
          </p>
        </div>
        <div className="w-1/5 flex justify-end items-center">
          <FaChevronRight className="text-light-blue-grey text-2xl" />
        </div>
      </Link>
    </li>
  );
};

const Offers = ({ items, isAgency, anchor, token }) => {
  const [_items, setItems] = useState([]);
  useEffect(() => {
    checkVenueForPreferredProgramme(token).then(response => {
      let filteredItems = items.filter(item => {
        let agencyProgrammes = [];
        let companyProgrammes = [];
        if (item.apply_to_preferred_programmes_only) {
          let venues = item.venues.map(venue => venue.id);

          if (response && response.agency) {
            agencyProgrammes = response.agency.filter(value =>
              venues.includes(value)
            );
          }
          if (response && response.company) {
            companyProgrammes = response.company.filter(value =>
              venues.includes(value)
            );
          }
          if (agencyProgrammes.length === 0 && companyProgrammes.length === 0) {
            return;
          } else {
            return (
              agencyTypes.includes(item.type.name) &&
              isOfferVisible(item, token)
            );
          }
        } else {
          return (
            agencyTypes.includes(item.type.name) && isOfferVisible(item, token)
          );
        }
      });
      setItems(filteredItems);
    });
  }, []);
  if (_items.length === 0) return null;

  return (
    <div className="bg-white shadow mb-6" id="offers">
      <span className="anchor" id={anchor}>
        Offers section
      </span>
      {isAgency && (
        <>
          <TrapezeHeader
            title={`Agency Offers / Rates`}
            textLeft
            bgColor="dark-red"
            bigText
          />
          <ul className="list-reset">{_items.map(renderOffer)}</ul>
        </>
      )}
    </div>
  );
};

Offers.propTypes = {
  items: arrayOf(
    shape({
      id: number.isRequired,
      title: string.isRequired,
      content: string.isRequired,
    })
  ).isRequired,
};

export default connect(state => ({
  isAgency: isAgency(state) || isInternal(state),
  token: token(state),
}))(Offers);
